import { useState } from 'react';
import api from '../../services/api';
import { X } from 'lucide-react';
import { motion } from 'framer-motion';

export default function CreateStudentModal({ isOpen, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    full_name: '',
    role: 'student',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    console.log('🚀 Iniciando criação de aluno...');
    console.log('📋 Dados do formulário:', formData);

    try {
      console.log('📡 Enviando requisição para /users...');
      const { data } = await api.post('/users', formData);
      console.log('✅ Resposta recebida:', data);
      onSuccess(data);
      onClose();
      // Reset form
      setFormData({
        email: '',
        password: '',
        full_name: '',
        role: 'student',
      });
    } catch (err) {
      console.error('❌ Erro completo:', err);
      console.error('❌ Resposta do servidor:', err.response);
      setError(err.response?.data?.details || err.response?.data?.error || 'Erro ao criar aluno');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className="relative bg-background-800 border border-gray-700 rounded-3xl p-8 max-w-md w-full"
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-text-primary">
            Criar Novo Usuário
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Nome Completo */}
          <div>
            <label className="block text-sm font-semibold text-text-primary mb-2">
              Nome Completo
            </label>
            <input
              type="text"
              value={formData.full_name}
              onChange={(e) => setFormData({...formData, full_name: e.target.value})}
              className="w-full px-4 py-3 bg-background-900 border-2 border-gray-700 rounded-2xl focus:border-primary-500 focus:ring-4 focus:ring-primary-500/20 transition-all text-text-primary"
              placeholder="Ex: João Silva"
              required
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-semibold text-text-primary mb-2">
              Email
            </label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              className="w-full px-4 py-3 bg-background-900 border-2 border-gray-700 rounded-2xl focus:border-primary-500 focus:ring-4 focus:ring-primary-500/20 transition-all text-text-primary"
              placeholder="usuario@email.com"
              required
            />
          </div>

          {/* Senha */}
          <div>
            <label className="block text-sm font-semibold text-text-primary mb-2">
              Senha
            </label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              className="w-full px-4 py-3 bg-background-900 border-2 border-gray-700 rounded-2xl focus:border-primary-500 focus:ring-4 focus:ring-primary-500/20 transition-all text-text-primary"
              placeholder="Mínimo 6 caracteres"
              minLength="6"
              required
            />
          </div>

          {/* Role */}
          <div>
            <label className="block text-sm font-semibold text-text-primary mb-2">
              Tipo de Usuário
            </label>
            <select
              value={formData.role}
              onChange={(e) => setFormData({...formData, role: e.target.value})}
              className="w-full px-4 py-3 bg-background-900 border-2 border-gray-700 rounded-2xl focus:border-primary-500 focus:ring-4 focus:ring-primary-500/20 transition-all text-text-primary cursor-pointer"
            >
              <option value="student">Aluno</option>
              <option value="admin">Administrador</option>
            </select>
            <p className="text-xs text-gray-500 mt-2">
              Usuários têm acesso apenas aos módulos. Administradores podem gerenciar todo o sistema.
            </p>
          </div>

          {/* Erro */}
          {error && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-red-500/10 border-2 border-red-500/50 text-red-400 px-4 py-3 rounded-2xl text-sm"
            >
              {error}
            </motion.div>
          )}

          {/* Botões */}
          <div className="flex space-x-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-2xl font-semibold transition-all"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 bg-primary-500 hover:bg-primary-600 text-white px-6 py-3 rounded-2xl font-semibold transition-all disabled:opacity-50 shadow-lg shadow-primary-500/20"
            >
              {loading ? 'Criando...' : 'Criar Usuário'}
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
}
